import Notifications from './notifications'
import LoginDialog from "./loginDialog/index"

const functions = {
    Notifications,
    LoginDialog
}

export default vm => {
    Object.values(functions).forEach((fnc) => {
        if(fnc.hasOwnProperty('subName')){
            vm.$ns[fnc.name][fnc.subName] = fnc.function
        } else {
            vm.$ns[fnc.name] = fnc.function
        }
    })
}
